module.exports = __webpack_public_path__ + "static/media/explore_04.d65b6c26.jpg";